G.Concrete = function(layer, cellX, cellY, hp) {
  G.BoardToken.call(this, layer, {
    tokenType: "concrete"
  }, cellX, cellY, hp);

  G.changeTexture(this, "concrete_"+this.hp);
};

G.Concrete.prototype = Object.create(G.BoardToken.prototype);

G.Concrete.prototype.onMatch = function() {
  G.sb("fx").dispatch('burstConcrete',this,this.hp);
  G.sfx.explosion_subtle.play();
  this.hp--;

  G.sb("fxTop").dispatch('burstConcreteAnim',this,this);

  G.sfx.brick_break.play();
  if (this.hp == 0) {
    this.remove();
  }else {
    G.changeTexture(this,'concrete_'+this.hp);
  }
};

G.Concrete.prototype.onBooster = function() {
  this.onMatch();
  return false;
};